import { render } from "./CategoryManager.vue?vue&type=template&id=7be2ce9b&scoped=true"
import script from "./CategoryManager.vue?vue&type=script&lang=js"
export * from "./CategoryManager.vue?vue&type=script&lang=js"

import "./CategoryManager.vue?vue&type=style&index=0&id=7be2ce9b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7be2ce9b"]])

export default __exports__